import { BaseAction } from "../../../../core/actions/BaseAction";
import { isEmpty } from "../../../../Lib/Utils/validationUtil";
import { IUserResponse } from "../../../../Orchestrator/Types/Index";
import { ITicketOption } from "../../../../Orchestrator/Types/Interface/ITicketOption";
import { IFavoriteTripsForTodayFields } from "../../../../Orchestrator/Types/Types/OffersResponse";
import { showNotification } from "../../../../Services/notificationService";
import { getTranslatedMessage } from "../../../../Lib/Utils/i18n";
import { updateRailPreferenceAction } from "./UpdateRailPreferenceAction";


interface IUpdateFavoriteTripForTodayParams {
    favoriteTripsForTodayFields: IFavoriteTripsForTodayFields[],
    ticketOptions: ITicketOption[],
    userData: IUserResponse
}

class UpdateFavoriteTripForTodayAction extends BaseAction<void, IUpdateFavoriteTripForTodayParams> {
    override async run(): Promise<void> {
        try {
            const { favoriteTripsForTodayFields, ticketOptions, userData } = this.params!;
            const preferredTrips: any[] = [];
            let currentTrip: any = {};
            favoriteTripsForTodayFields.forEach((field) => {
                if (!isEmpty(field.value)) {
                    if (field.name === 'from') {
                        currentTrip['origin'] = field.value;
                    } else if (field.name === 'to') {
                        currentTrip['destination'] = field.value;
                    } else if (field.name === 'classTicketOption') {
                        const classType = field.value;
                        currentTrip['classType'] = classType;

                        const matchedOption = ticketOptions.find(
                            d => d.serviceClass === classType && d.value === field.valueCode
                        );
                        currentTrip['ticketOption'] = matchedOption?.value || field.valueCode || "";
                    }
                }
            });
            preferredTrips.push(currentTrip);

            const payload = {
                railPreferences: {
                    ...userData.railPreferences,
                    preferredTrips: preferredTrips
                }
            };
            updateRailPreferenceAction.setParams({ payload, userId: userData.id });
            await updateRailPreferenceAction.execute();
            showNotification("success", getTranslatedMessage("favoriteTripUpdatedSuccessfully", "Favorite trip for today updated successfully"), "");
        } catch (error: any) {
            console.log("Error updatePersonalizeExperience", error?.message);
        }
    }
}

export const updateFavoriteTripForTodayAction = new UpdateFavoriteTripForTodayAction();
